import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin'; 

import { DLogger } from '@dian/core';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DDocumento } from '@dian/api-formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DConceptoPago, DItemConcepto, DPais } from '@dian-api/rtefte350';
import { DBasicosParametricasServicios, DLugar, DValorDominio } from '@dian/api-basicos-parametricas';

const valorDominioConceptosSinConvenio = "1223";
const valorDominioConceptosConConvenio = "1637";

@Component({
  selector: 'conceptos-component',
  templateUrl: './conceptos.component.html',
  styleUrls: ['./conceptos.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DOperacionesMatematicasServicio,
    DNotificacionServicio,
    DBasicosParametricasServicios  
  ]
})
export class ConceptosComponent implements OnInit {

	public showSeccion: boolean = false;
	public addConcepto: boolean = false;
	public agregarEditarItem: boolean = false;
	public conceptoPago: DConceptoPago;	
	public listPaises: Array<DLugar>;
  public listConceptos: Array<DConceptoPago>;
  public listConceptosAgregados: Array<DConceptoPago>;

	private indexEditConcepto: number;
	private indexEditItem: number;

	@Input() title: string;
	@Input() anioAyudas: string | number;
  @Input() convenio: boolean;
  @Input() modelo: any | DDocumento;
  @Input() editableComponente: boolean;
	@Output() notificarConceptos: EventEmitter<any> = new EventEmitter<any>();


  constructor(
  	private dutilidades: DOperacionesMatematicasServicio, 
  	private dNotificacionServicio: DNotificacionServicio,
    private dServicioRESBasicosParametricas: DBasicosParametricasServicios,
    private logger: DLogger
  ) {
  	this.conceptoPago = new DConceptoPago();
  	this.listConceptos = new Array<DConceptoPago>();
  	this.listConceptosAgregados = new Array<DConceptoPago>();  	
  }

  ngOnInit() {
    setTimeout(() => {
      this.obtenerDatosServicios();
    }, 10);    
  }

  /**
   * @desc Funcion para cambiar el foco de los input
   * @function processKeyUp
   * @ignore
   * @param {Event} e evento que contiene el keycode
   * @param {HtmlElement} el a pasar el foco
   * @param {boolean} remover foco cuando no hay mas donde pasar el foco para que la casilla se formatie, entonces ejecuta el evento blur
   * es necesario que el parametro el apunte al el mismo elemento que esta llamando la funci�n
   */
  private cambioFocoCasillas(e, el, remover?:boolean) {
    if (!remover) {
      if (e.keyCode == 13) el.focus();
    } else el.blur();
  }

  /*======== Metodos de adicion y eliminación de conceptos ========*/

  /**
  * @desc Funcion que obtiene los paises y conceptos para mostrarlos
  */
  private obtenerDatosServicios() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga(); 
    let observablePaises = this.dServicioRESBasicosParametricas.obtenerPaises();
    let valorDominioConceptos = this.convenio? valorDominioConceptosConConvenio : valorDominioConceptosSinConvenio;
    let observableConceptos = this.dServicioRESBasicosParametricas.obtenerValoresDominio(valorDominioConceptos);

    Observable.forkJoin([
      observablePaises,
      observableConceptos
    ]).subscribe((res) => {
      this.listPaises = <Array<DLugar>>res[0];
      let valoresDominio = res[1];
      for (let i in valoresDominio) {
        if (typeof valoresDominio[i] === 'object') {
          let concepto = new DConceptoPago();
          concepto.id = valoresDominio[i].valor;
          concepto.nombre = valoresDominio[i].nombre;
          concepto.itemEdicion = null;
          concepto.items = new Array<DItemConcepto>();
          concepto.subTotalBases = null;
          concepto.subTotalRetencion = null;
          concepto.agregarEditarItem = false;
          this.listConceptos.push(concepto);
        }          
      }

      //Ordenar los conceptos por id
      this.listConceptos.sort((a: any, b: any) => {
        return a.id - b.id;
      });
      
      this.traducirModeloAListasConceptos();
      precarga.close()
    }, error =>{
      precarga.close()
      this.logger.error("Error obteniendo valores dominio para concepto o paises ", error);
    });    
  }


  /**
  * @desc Funcion para calcular el valor de la retencion de un item
 	* @param {DConceptoPago} item
  */
  public calcularValorRetencion(item: DItemConcepto) {    
  	let cas93 = item.cc_id_93;
    let cas94 = item.cc_id_94;

    if (cas94 && cas94.length > 2) {
      let esDecimal = cas94.indexOf('.') > -1;
      if (!esDecimal) {
        cas94 = 0;
        item.cc_id_94 = 0;
      }
      if (esDecimal) {
        let cantidadNum = cas94.split('.')[0].length;
        if (cantidadNum === 3) {
          cas94 = 0;
          item.cc_id_94 = 0;
        } else {
          item.cc_id_94 = item.cc_id_94.replace(/^0+/, '');
        }
      }
    }
    
    let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas93, cas94, false);
    let resultadoPorcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, resultadoMultiplicacion, "100", true);
    let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoPorcentaje, "0" ) ? "0" : resultadoPorcentaje;
    item.cc_id_95 = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
    //Redondear valores casillas
    item.cc_id_93 = this.dutilidades.redondearValorMoneda(item.cc_id_93, true); 
  }

  /**
  * @desc Funcion para agregar un concepto de pago
  */
  public addConceptoPago() {
    if (!this.conceptoPago.hasOwnProperty('id') || !this.conceptoPago.id) {
      this.dNotificacionServicio.mostrarDialogoInformacion("Seleccione un concepto."); 
      return; 
    }
    
    if (!this.validarExisteConceptoCreado(this.conceptoPago)) {
  		let concepto = new DConceptoPago();
      Object.assign(concepto, this.conceptoPago);
      this.addConcepto = false;
      concepto.itemEdicion = new DItemConcepto();
      this.listConceptosAgregados.unshift(concepto);
  	} else {
  		this.dNotificacionServicio.mostrarDialogoInformacion("El concepto ya se encuentra agregado.");  
  	}
  }

  /**
  * @desc Funcion para eliminar un concepto de pago
  * @param {Number} index
  */
  public eliminarConcepto(index: number) {
  	this.listConceptosAgregados.splice(Number(index), 1);
    this.notificarConceptos.emit(this.listConceptosAgregados);
  }

  /**
  * @desc Funcion para agregar un item a un concepto de pago
  * @param {Number} index
  */  
  public addItemConcepto(index: number) {
  	let item = this.listConceptosAgregados[index].itemEdicion;
    item.cc_id_90 = this.convenio ? '2' : '1';
    item.cc_id_91 = String(this.listConceptosAgregados[index].id);
  	this.listConceptosAgregados[index].items.push(item);
  	this.listConceptosAgregados[index].itemEdicion = new DItemConcepto();
  	this.resultadosSumasItemsConcepto(index);
  }

  /**
  * @desc Funcion para eliminar un item del concepto de pago
  * @param {Number} indexConcepto
  * @param {Number} indexItem
  */
  public eliminarItemConcepto(indexConcepto: number, indexItem: number) {
  	this.listConceptosAgregados[Number(indexConcepto)].items.splice(Number(indexItem), 1);
  	this.resultadosSumasItemsConcepto(indexConcepto);
  }

  /**
  * @desc Funcion para editar un item de un concepto de pago
  * @param {DItemConcepto} item
  * @param {Number} indexConcepto
  * @param {Number} indexItem
  */
  public editarItemConcepto(item: DItemConcepto, indexConcepto: number, indexItem: number) {
  	item.edicion = true;
  	Object.assign(this.listConceptosAgregados[indexConcepto].itemEdicion, item);
  	this.indexEditConcepto = indexConcepto;
  	this.indexEditItem = indexItem;
  }

  /**
  * @desc Funcion para cancelar la edicion de un item
  * @param {Number} index
  */
  public cancelEditItem(index: number) {
  	this.indexEditConcepto = null;
  	this.indexEditItem = null;
  	this.listConceptosAgregados[index].itemEdicion = new DItemConcepto();
  }

  /**
  * @desc Funcion para actualizar el item del concepto al dar click en actualizar
  * @param {Number} index
  */
  public actualizarItemConcepto(index: number) {
  	Object.assign(this.listConceptosAgregados[this.indexEditConcepto].items[this.indexEditItem], this.listConceptosAgregados[this.indexEditConcepto].itemEdicion);
  	this.resultadosSumasItemsConcepto(index);
  }

  /**
  * @desc Funcion para sumar los valores de bases y retenciones de los items por concepto
  * @param {Number} index
  */
  private resultadosSumasItemsConcepto(index:number) {
  	let subBases: string = "0";
  	let subRet: string = "0";

  	for (let i in this.listConceptosAgregados[index].items) {
  		let item = this.listConceptosAgregados[index].items[i];
  		subBases = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, String(subBases), item.cc_id_93, false);
  		subRet = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, String(subRet), item.cc_id_95, false);
  	}

  	this.listConceptosAgregados[index].subTotalBases = this.dutilidades.redondearValorMoneda(String(subBases), true);
		this.listConceptosAgregados[index].subTotalRetencion = this.dutilidades.redondearValorMoneda(String(subRet), true);
		//Notifica al componente padre que se realizaron cambios para realizar los calculos de nuevo
		this.notificarConceptos.emit(this.listConceptosAgregados);
  }

  /**
  * @desc Funcion para validar antes de agregar el concepto si este ya fue agregado para no permitir agregarlo de nuevo
  * @param {DConceptoPago} concepto
  * @return {Boolean}
  */
  private validarExisteConceptoCreado(concepto: DConceptoPago): boolean {
  	let bandera = false;
  	for (let i in this.listConceptosAgregados) {
  		bandera = this.listConceptosAgregados[i].id === concepto.id;
  		break;
  	}
  	return bandera;
  }
  
  /**
  * @desc Funcion que traduce el modelo al array necesario para la funcionalidad del formulario
  */
  private traducirModeloAListasConceptos() {
    if (!this.modelo || !this.modelo.hasOwnProperty('doc')) return;

    let codigoConvenio = this.convenio ? '2' : '1';
    let arr = this.obtenerListPorConvenio(codigoConvenio);   
    let arrIdConceptos = [];

    //obtengo primero los conceptos sin repetir
    for (let i in this.modelo.doc.cuerpo.cc_id_91) {
      if(!(arrIdConceptos.indexOf(this.modelo.doc.cuerpo.cc_id_91[i].v) > -1)) {
        arrIdConceptos.push(this.modelo.doc.cuerpo.cc_id_91[i].v);
      }
    }

    // Recorro el arr de id de conceptos y luego se recorre la lista discrminidad por concepto y se van creando los objetos y los agrego a la lista que se muestra en el componente
    for (let i in arrIdConceptos) {
      let concepto = this.obtenerConcepto(arrIdConceptos[i]); 
      if(concepto){
        concepto.items = new Array<DItemConcepto>(); 
        concepto.itemEdicion = new DItemConcepto();
        let arrConceptos = this.obtenerListaPorConcepto(arrIdConceptos[i], arr);

        for (let c in arrConceptos) {
          let pais = this.obtenerPais(arrConceptos[c].cc_id_92);      
          let item = new DItemConcepto();
          item.cc_id_90 = arrConceptos[c].cc_id_90;
          item.cc_id_91 = concepto.id;
          item.cc_id_92 = pais;
          item.cc_id_93 = arrConceptos[c].cc_id_93;
          item.cc_id_94 = arrConceptos[c].cc_id_94;
          item.cc_id_95 = arrConceptos[c].cc_id_95;
          item.edicion = false;
          concepto.items.push(item); 
        }
            
        if (concepto.items.length) { 
          this.listConceptosAgregados.push(concepto);        
          setTimeout(() => {          
            this.inicializarTotalesArrayConstruido();                       
          }, 10);
        }
      }
    }
  }

  /**
  * @desc Function que calculo los totales cuando los valores han sido armados en la estructura de la aplicación 
  * al momento que el documento llega de una respuesta JSON
  */
  private inicializarTotalesArrayConstruido() {
    if (!this.listConceptosAgregados || !this.listConceptosAgregados.length) return;

    for (let index in this.listConceptosAgregados) {
      let subBases: string = "0";
      let subRet: string = "0";
    
      for (let i in this.listConceptosAgregados[index].items) {
        let item = this.listConceptosAgregados[index].items[i];
        subBases = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, String(subBases), item.cc_id_93, false);
        subRet = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, String(subRet), item.cc_id_95, false);
      }
    
      this.listConceptosAgregados[index].subTotalBases = this.dutilidades.redondearValorMoneda(String(subBases), true);
      this.listConceptosAgregados[index].subTotalRetencion = this.dutilidades.redondearValorMoneda(String(subRet), true);      
    }
    //Notifica al componente padre que se realizaron cambios para realizar los calculos de nuevo
    this.notificarConceptos.emit(this.listConceptosAgregados);
  }

  /**
  * @desc Funcion que obtiene la lista por concepto
  * @param {String} id
  * @param {Array} list
  * @return {Array}
  */
  private obtenerListaPorConcepto(id: string, list: Array<any>) {
    let arr = [];
    for (let i in list) {      
      if (list[i].cc_id_91 == id) {
        arr.push(list[i]);
      }
    }
    return arr;
  }

  /**
  * @desc Funcion que obtiene la lista de los que tienen o no convenio segun variable convenio y luego se ordena por codigo de concepto
  * @param {String} codigoConvenio
  * @return {Array}
  */
  private obtenerListPorConvenio(codigoConvenio: string) {
    if (!this.modelo || !this.modelo.hasOwnProperty('doc')) return;
    let arr = [];    

    for (let i in this.modelo.doc.cuerpo.cc_id_90) {
      if (this.modelo.doc.cuerpo.cc_id_90[i].v == codigoConvenio) {
        let obj = {
          cc_id_90: this.modelo.doc.cuerpo.cc_id_90[i].v, 
          cc_id_91: this.modelo.doc.cuerpo.cc_id_91[i].v,
          cc_id_92: this.modelo.doc.cuerpo.cc_id_92[i].v,
          cc_id_93: this.modelo.doc.cuerpo.cc_id_93[i].v,
          cc_id_94: this.modelo.doc.cuerpo.cc_id_94[i].v,
          cc_id_95: this.modelo.doc.cuerpo.cc_id_95[i].v
        }
        arr.push(obj);
      }
    }

    //Ordenamiento
    arr.sort((item1, item2) => {
      if (Number(item1.cc_id_91.v) < Number(item2.cc_id_91.v)) return -1;
      else if (Number(item1.cc_id_91.v) > Number(item2.cc_id_91.v)) return 1;
      else return 0;
    });

    return arr;
  }

  /**
  * @desc Funcion para obtener el pais segun el dato del modelo
  * @param {String} id
  * @return {DLugar}
  */
  private obtenerPais(id: string): DLugar {
    for (let i in this.listPaises) {
      if (String(this.listPaises[i].codigoNum) == id) {
        return <DLugar>this.listPaises[i];
      }
    }
  }

  /**
  * @desc Funcion para obtener el concepto segun el dato del modelo
  * @param {String} id
  * @return {DConceptoPago}
  */
  private obtenerConcepto(id: string): DConceptoPago {
    for (let i in this.listConceptos) {
      if (this.listConceptos[i].id == id) {
        return <DConceptoPago>this.listConceptos[i];
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/directives/conceptos/conceptos.component.ts